<template>
  <div class="no-results-placeholder mt-4">
    <div class="card">
      <div class="card-body text-center py-5 px-5">

        <div class="width--85perwh mx-auto text-left">
          <h1 v-if="isEmptyBookmarkFolder" class="t-600 t-secondary mb-4">
            Looks like nothing has been added to this folder yet.
          </h1>
          <h1 v-else-if="keyword" class="t-600 t-secondary mb-4">
            <span class="t-primary">{{ keyword }}</span> has no results<template v-if="index"> for <span class="t-primary">{{getIndexAsString(index) | humanize}}</span></template>.
          </h1>
          <h1 v-else class="t-600 t-secondary mb-4">
            We couldn't find any results for this query.
          </h1>

          <template v-if="isEmptyBookmarkFolder">
            <span class="t-600 pb-2 d-block">Start adding items to this bookmark folder</span>
            <ul class="mb-0 t-600 pl-4">
              <li><router-link :to="{ name: 'searchHome' }">Search AcademicLabs</router-link></li>
              <li>Save your search results to this folder</li>
            </ul>
          </template>
          <template v-else>
            <ul class="mb-0 t-600 pl-4">
              <li>Did you make a typo?</li>
              <li>Maybe try a related term?</li>
            </ul>
          </template>

          <template v-if="!isEmpty(parsedIndices)">
            <p class="mt-4 mb-3">We did find results for these categories:</p>
            <router-link
              v-for="result in parsedIndices"
              :to="getCategoryLink(result.value)"
              :key="result.value"
              class="btn btn-primary t-white mr-2 mb-2 t-600"
            >
              {{ result.count }} {{ getIndexAsString(result.value) }}
            </router-link>
          </template>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCategoryLink } from '@/plugins/utils'

export default {
  name: 'searchNoResults',
  props: {
    indexes: {
      type: Object,
      required: false,
      default: () => {}
    },
    index: {
      type: String,
      required: false,
      default: ''
    },
    keyword: {
      type: String,
      required: false,
      default: ''
    },
    isEmptyBookmarkFolder: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    parsedIndices () {
      const arr = []
      for (let index in this.indexes) {
        if (this.indexes[index].total > 0) {
          arr.push({
            value: index,
            count: this.indexes[index].total
          })
        }
      }
      return arr
    }
  },
  methods: {
    getCategoryLink (category) {
      return getCategoryLink(this.searchView(category), this.$route, category)
    }
  }
}
</script>
